import React, {
  useContext,
  useState,
  useCallback,
  useRef,
  useEffect,
} from "react";
import { StaffType } from "../../types/StaffType";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  checkExternalLink,
  createHost,
  deleteHost,
  getListHost,
  syncDataHost,
  updateHost,
  updateHostIndex,
  updateHostSortIndex,
} from "../../api/host";
import { handleErrorMessage } from "../../utils/helper/common";
import CustomNotification from "../CustomNotification";
import { queryKeys } from "../../constants/constans";
import { StatusWorking } from "../../constants/enum";
import { Button, Col, Form, Modal, Pagination, Rate, Row } from "antd";
import styles from "./styles.module.scss";
import StaffComponent from "../Staff";
import moment from "moment";
import Cookies from "js-cookie";
import useNetworkStatus from "hooks/useNetworkStatus";
import { v4 as uuidv4 } from "uuid";
import { getDefaultConfigOfTable } from "../../api/table";
import classNames from "classnames";

type ModalStaffConfigType = {
  showStaffModal: boolean;
  setStaffModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ModalStaffConfig = (props: ModalStaffConfigType) => {
  const createHostAction = useMutation(createHost);
  const deleteHostAction = useMutation(deleteHost);
  const updateHostAction = useMutation(updateHost);
  const syncDataHostAction = useMutation(syncDataHost);
  const updateHostIndexAction = useMutation(updateHostIndex);
  const updateHostSortIndexAction = useMutation(updateHostSortIndex);
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const [ranking, setRanking] = useState<number>(1);
  const isOnline = useNetworkStatus();
  const mustSync = useRef<boolean>(false);

  const { data: listHost, refetch } = useQuery(
    queryKeys.listHost,
    getListHost,
    {
      onError: (err) => handleErrorMessage(err),
      onSuccess: (data) => {
        if (Array.isArray(data?.data)) {
          // const listStaffWorking = data?.data?.filter((item: any) =>
          //   [StatusWorking.Working, StatusWorking.WorkingLate].includes(
          //     item?.statusWorking
          //   )
          // );
          Cookies.set(queryKeys.listHost, JSON.stringify(data?.data));

          setZaisekiStaffList(data?.data || []);
        }
      },
      initialData: Cookies.get(queryKeys?.listHost)
        ? JSON.parse(Cookies.get(queryKeys?.listHost) || "{}")
        : null,
    }
  );

  useEffect(() => {
    if (showStaffModal) {
      setRanking(1);
      document.body.classList.add("disableOverflow");
    } else {
      document.body.classList.remove("disableOverflow");
    }
  }, [props.showStaffModal]);

  const { showStaffModal, setStaffModal } = props;
  const staffIdDrag = useRef<string>("");
  const dragInRanking = useRef<boolean>(false);

  //スタッフ追加用フォーム
  const [formText, setFormText] = useState<string>();

  //在籍リスト
  const [zaisekiStaffList, setZaisekiStaffList] = useState<StaffType[]>([]);

  //スタッフリストのどの要素をドラッグされたか
  const [dragIndex1, setDragIndex1] = useState<number | null>(null);
  const [dragIndex2, setDragIndex2] = useState<number | null>(null);

  //どこのエリアからドラッグされたか
  const [isFromArea1, setIsFromArea1] = useState<boolean>(false);
  const [isFromArea2, setIsFromArea2] = useState<boolean>(false);
  const [isFromArea3, setIsFromArea3] = useState<boolean>(false);
  const [viewSettingRanking, setViewSettingRanking] = useState<boolean>(false);

  useEffect(() => {
    if (!!isOnline && mustSync.current) {
      syncDataHostAction.mutate(listHost);
    }
  }, [isOnline]);

  const { data: defaultConfig } = useQuery(
    queryKeys.defaultConfigTable,
    getDefaultConfigOfTable
  );

  const UnshowStaffModal = useCallback(() => setStaffModal(false), []);
  const handleChange = (e: any) => {
    setFormText(e.target.value);
  };

  const handleCloseModal = () => {
    updateHostIndexAction.mutate({ data: zaisekiStaffList });
    const sortData = zaisekiStaffList.map((staff, idx) => ({
      id: staff.id,
      index: idx,
    }));
    updateHostSortIndexAction.mutate({ data: sortData });
    UnshowStaffModal();
    form.resetFields();
  };

  //ドラッグ＆ドロップ系処理ここから
  const dragStart1 = (index: number) => {
    //スタッフIDをドラッグしている情報
    if (setDragIndex1 != undefined) {
      setDragIndex1(index);
    }

    //ドラッグエリアの識別
    setIsFromArea1(() => true);
    setIsFromArea2(() => false);
    setIsFromArea3(() => false);
  };

  const dragStart2 = (index: number) => {
    //スタッフIDをドラッグしている情報
    if (setDragIndex2 != undefined) {
      setDragIndex2(index);
    }

    //ドラッグエリアの識別
    setIsFromArea2(() => true);
    setIsFromArea1(() => false);
    setIsFromArea3(() => false);
  };

  const dragStart3 = (index: number) => {
    //ドラッグエリアの識別
    setIsFromArea3(() => true);
    setIsFromArea2(() => false);
    setIsFromArea1(() => false);
  };

  const dragEnter = (index: number) => {
    const listStaffCurrent = zaisekiStaffList
      .filter(
        (item) =>
          item?.infoWorking?.statusWorking &&
          [StatusWorking.Working, StatusWorking.WorkingLate].includes(
            item?.infoWorking?.statusWorking
          )
      )
      .sort((a, b) => Number(a.orderWorking) - Number(b.orderWorking));
    const realIndex = listStaffCurrent?.findIndex(
      (item) => item?.id === staffIdDrag.current
    );
    if (index === realIndex || realIndex === -1) return;
    const deleteElement = listStaffCurrent.splice(realIndex, 1)[0];

    listStaffCurrent.splice(index, 0, deleteElement);
    const listStaff = zaisekiStaffList.map((item) => {
      const index = listStaffCurrent?.findIndex(
        (staff) => staff?.id === item?.id
      );

      return {
        ...item,
        orderWorking: index === -1 ? undefined : index,
      };
    });

    setZaisekiStaffList([...listStaff]);
  };

  const dragEnterZaiseki = (index: number) => {
    const realIndex = zaisekiStaffList.findIndex(
      (item) => item?.id === staffIdDrag.current
    );
    if (index === realIndex || realIndex === -1) return;
    const listStaffNew = [...zaisekiStaffList];
    const [moved] = listStaffNew.splice(realIndex, 1);
    listStaffNew.splice(index, 0, moved);
    setZaisekiStaffList(listStaffNew);
  };

  const dragEnd = (index: number) => {};

  const onDrop1 = (e: React.DragEvent<HTMLDivElement>) => {
    if (!staffIdDrag.current) return;
    if (!!viewSettingRanking && !isFromArea1) {
      updateHostAction.mutate(
        {
          hostId: staffIdDrag.current,
          data: { rankingRandom: 0 },
        },
        {
          onError: (err) => {
            if (!!isOnline) {
              handleErrorMessage(err);
              return;
            }
            mustSync.current = true;

            const listHost = queryClient.getQueryData(
              queryKeys.listHost
            ) as any;
            if (listHost?.data && Array.isArray(listHost?.data)) {
              const listHostNew = listHost.data.map((item: any) => {
                if (item?.id === staffIdDrag.current) {
                  return {
                    ...item,
                    infoWorking: {
                      ...item?.infoWorking,
                      rankingRandom: ranking,
                    },
                    mustSync: true,
                  };
                }
                return item;
              });
              queryClient.setQueryData(queryKeys.listHost, {
                data: listHostNew,
              });
              setIsFromArea2(false);
              setIsFromArea1(false);
              setIsFromArea3(false);
              staffIdDrag.current = "";
            }
          },
          onSuccess: (data) => {
            refetch();
            setIsFromArea2(false);
            setIsFromArea1(false);
            setIsFromArea3(false);
            staffIdDrag.current = "";
          },
        }
      );
    } else {
      if (isFromArea1) return;
      updateHostAction.mutate(
        {
          hostId: staffIdDrag.current,
          data: { statusWorking: StatusWorking.NotSet },
        },
        {
          onError: (err) => {
            if (!!isOnline) {
              return;
            }
            mustSync.current = true;

            const listHost = queryClient.getQueryData(
              queryKeys.listHost
            ) as any;

            if (listHost?.data && Array.isArray(listHost?.data)) {
              const listHostNew = listHost.data.map((item: any) => {
                if (item?.id === staffIdDrag.current) {
                  return {
                    ...item,
                    infoWorking: {
                      ...item?.infoWorking,
                      statusWorking: StatusWorking.NotSet,
                    },
                    mustSync: true,
                  };
                }
                return item;
              });
              queryClient.setQueryData(queryKeys.listHost, {
                data: listHostNew,
              });
              setIsFromArea2(false);
              setIsFromArea1(false);
              setIsFromArea3(false);
              staffIdDrag.current = "";
            }
          },
          onSuccess: (data) => {
            refetch();
            setIsFromArea2(false);
            setIsFromArea1(false);
            setIsFromArea3(false);
            staffIdDrag.current = "";
          },
        }
      );
    }
  };

  const onDrop2 = (e: React.DragEvent<HTMLDivElement>) => {
    if (!!viewSettingRanking) return;

    const staffItem = zaisekiStaffList.find(
      (item) => item.id === staffIdDrag.current
    );
    if (
      (staffItem?.infoWorking?.statusWorking &&
        [StatusWorking.Working, StatusWorking.WorkingLate].includes(
          staffItem?.infoWorking?.statusWorking
        ) &&
        isFromArea1) ||
      isFromArea2
    ) {
      if (!isFromArea2) {
        if (ranking === staffItem?.ranking) {
          CustomNotification({
            description: "既に出勤リストに追加済みです。 ",
            message: "",
            type: "error",
          });
        } else {
          CustomNotification({
            description: "既に別なページに追加されています。 ",
            message: "",
            type: "error",
          });
        }
      }
      return;
    }
    if (!staffIdDrag.current) return;

    updateHostAction.mutate(
      {
        hostId: staffIdDrag.current,
        data: { statusWorking: StatusWorking.Working, ranking },
      },
      {
        onError: (err) => {
          if (!!isOnline) {
            handleErrorMessage(err);
            return;
          }
          mustSync.current = true;

          const listHost = queryClient.getQueryData(queryKeys.listHost) as any;

          if (listHost?.data && Array.isArray(listHost?.data)) {
            const listHostNew = listHost.data.map((item: any) => {
              if (item?.id === staffIdDrag.current) {
                return {
                  ...item,
                  infoWorking: {
                    ...item?.infoWorking,
                    statusWorking: StatusWorking.Working,
                  },
                  mustSync: true,
                };
              }
              return item;
            });
            queryClient.setQueryData(queryKeys.listHost, { data: listHostNew });
            setIsFromArea2(false);
            setIsFromArea1(false);
            setIsFromArea3(false);
            staffIdDrag.current = "";
          }
        },
        onSuccess: (data) => {
          refetch();
          setIsFromArea2(false);
          setIsFromArea1(false);
          setIsFromArea3(false);
          staffIdDrag.current = "";
        },
      }
    );
  };

  const onDrop3 = (e: React.DragEvent<HTMLDivElement>) => {
    if (!!viewSettingRanking) return;
    const staffItem = zaisekiStaffList.find(
      (item) => item.id === staffIdDrag.current
    );
    if (
      (staffItem?.infoWorking?.statusWorking &&
        [StatusWorking.WorkingLate].includes(
          staffItem?.infoWorking?.statusWorking
        ) &&
        isFromArea2) ||
      !isFromArea2 ||
      isFromArea3
    ) {
      return;
    }
    if (!staffIdDrag.current) return;

    updateHostAction.mutate(
      {
        hostId: staffIdDrag.current,
        data: { statusWorking: StatusWorking.WorkingLate },
      },
      {
        onError: (err) => {
          if (!!isOnline) {
            handleErrorMessage(err);
            return;
          }
          mustSync.current = true;

          const listHost = queryClient.getQueryData(queryKeys.listHost) as any;
          if (listHost?.data && Array.isArray(listHost?.data)) {
            const listHostNew = listHost.data.map((item: any) => {
              if (item?.id === staffIdDrag.current) {
                return {
                  ...item,
                  infoWorking: {
                    ...item?.infoWorking,
                    statusWorking: StatusWorking.WorkingLate,
                  },
                  mustSync: true,
                };
              }
              return item;
            });
            queryClient.setQueryData(queryKeys.listHost, { data: listHostNew });
            setIsFromArea2(false);
            setIsFromArea1(false);
            setIsFromArea3(false);
            staffIdDrag.current = "";
          }
        },
        onSuccess: (data) => {
          refetch();
          setIsFromArea2(false);
          setIsFromArea1(false);
          setIsFromArea3(false);
          staffIdDrag.current = "";
        },
      }
    );
  };

  const onDropRanking = (ranking: number) => {
    if (!viewSettingRanking) return;

    const listStaffInRanking = zaisekiStaffList.filter(
      (item: any) => item.rankingRandom === ranking
    );

    const staff = zaisekiStaffList.find(
      (item: any) =>
        item?.rankingRandom === ranking && item?.id === staffIdDrag.current
    );

    if (!!staff && !!dragInRanking.current) return;

    if (!!staff) {
      CustomNotification({
        type: "error",
        message: "スタッフが既に登録されました。",
        description: "",
      });
      return;
    }

    if (listStaffInRanking?.length >= 2) {
      CustomNotification({
        type: "error",
        message: "2名以上登録できません。",
        description: "",
      });
      return;
    }

    updateHostAction.mutate(
      {
        hostId: staffIdDrag.current,
        data: { rankingRandom: ranking },
      },
      {
        onError: (err) => {
          if (!!isOnline) {
            handleErrorMessage(err);
            return;
          }
          mustSync.current = true;

          const listHost = queryClient.getQueryData(queryKeys.listHost) as any;
          if (listHost?.data && Array.isArray(listHost?.data)) {
            const listHostNew = listHost.data.map((item: any) => {
              if (item?.id === staffIdDrag.current) {
                return {
                  ...item,
                  infoWorking: {
                    ...item?.infoWorking,
                    rankingRandom: ranking,
                  },
                  mustSync: true,
                };
              }
              return item;
            });
            queryClient.setQueryData(queryKeys.listHost, { data: listHostNew });
            setIsFromArea2(false);
            setIsFromArea1(false);
            setIsFromArea3(false);
            staffIdDrag.current = "";
            dragInRanking.current = false;
          }
        },
        onSuccess: (data) => {
          refetch();
          setIsFromArea2(false);
          setIsFromArea1(false);
          setIsFromArea3(false);
          staffIdDrag.current = "";
          dragInRanking.current = false;
        },
      }
    );
  };

  const onDropTrash = async (e: React.DragEvent<HTMLDivElement>) => {
    if (dragIndex1 != null && isFromArea1) {
      const staffInfo = zaisekiStaffList?.find(
        (item: any) => item?.id === staffIdDrag.current
      );
      if (
        staffInfo?.infoWorking?.statusWorking &&
        [StatusWorking.Working, StatusWorking.WorkingLate].includes(
          staffInfo?.infoWorking?.statusWorking
        )
      ) {
        alert("出勤したスタッフを削除できません。");
        return;
      }

      const hostIdToDelete = staffIdDrag.current;

      const doDelete = () => {
        deleteHostAction.mutate(hostIdToDelete, {
          onError: (err) => {
            if (!!isOnline) {
              handleErrorMessage(err);
              return;
            }
            mustSync.current = true;

            const listHost = queryClient.getQueryData(queryKeys.listHost) as any;
            if (listHost?.data && Array.isArray(listHost?.data)) {
              const listHostNew = listHost.data.filter((item: any) => {
                return item?.id !== hostIdToDelete;
              });
              queryClient.setQueryData(queryKeys.listHost, { data: listHostNew });
              setIsFromArea2(false);
              setIsFromArea1(false);
              setIsFromArea3(false);
              staffIdDrag.current = "";
            }
          },
          onSuccess: (data) => {
            CustomNotification({
              type: "success",
              description: "スタッフを削除しました。",
              message: "成功",
            });
            refetch();
            setIsFromArea1(false);
          },
        });
      };

      try {
        const res = await checkExternalLink(hostIdToDelete);
        const linkData = res?.data as { linked: boolean; externalStoreId?: string };
        if (linkData?.linked) {
          Modal.confirm({
            title: "外部連携スタッフの削除確認",
            content: `このスタッフは otokobon-digital（店舗ID: ${linkData.externalStoreId}）と連携されています。削除すると otokobon 側のキャストも非アクティブ化されます。続けますか?`,
            okText: "削除する",
            cancelText: "キャンセル",
            onOk: doDelete,
          });
        } else {
          doDelete();
        }
      } catch {
        doDelete();
      }
    }
  };

  //スタッフ追加

  const handleAddStaff = (values: any) => {
    createHostAction.mutate(
      {
        staffName: values?.staffName,
      },
      {
        onError: (err) => {
          if (!!isOnline) {
            handleErrorMessage(err);
            return;
          }
          mustSync.current = true;
          const userString = Cookies.get("profileRemember");
          const listHost = queryClient.getQueryData(queryKeys.listHost) as any;

          if (userString) {
            const user = JSON.parse(userString);

            if (
              Number(user?.data?.plan) === 1 &&
              listHost?.data &&
              Array.isArray(listHost?.data) &&
              listHost?.data?.length >= 25
            ) {
              CustomNotification({
                description:
                  "スタッフを追加するため、プランをアップグレードしてください。",
                message: "",
                type: "error",
              });
              return;
            }
          }
          if (listHost?.data && Array.isArray(listHost?.data)) {
            listHost?.data.push({
              staffName: values?.staffName,
              infoWorking: {
                status: StatusWorking.NotSet,
              },
              mustSync: true,
              isAdd: true,
              id: uuidv4(),
              updatedAt: moment().valueOf(),
            });

            queryClient.setQueryData(queryKeys.listHost, listHost);
            CustomNotification({
              description: "従業員を正常に追加しました",
              message: "成功",
              type: "success",
            });
            form.resetFields();
          }
        },
        onSuccess: (data) => {
          refetch();
          CustomNotification({
            description: "従業員を正常に追加しました",
            message: "成功",
            type: "success",
          });
          form.resetFields();
        },
      }
    );
  };

  const handleChangeOrderStaff = (staffId: string, star: number) => {
    const zaisekiStaffListNew = zaisekiStaffList?.map((item) => {
      if (item.id === staffId) {
        return {
          ...item,
          star: star,
          updatedAt: moment().toISOString(),
          mustSync: !isOnline,
          orderWorking: star ? 0 : item?.orderWorking,
          mustUpdate: true,
        };
      }
      return item;
    });
    zaisekiStaffListNew.sort((a, b) => {
      const starDifference = Number(b.star) - Number(a.star);
      if (starDifference !== 0) {
        return starDifference;
      }
      // So sánh updatedAt nếu star bằng nhau
      const dateA = moment(a.updatedAt).valueOf();
      const dateB = moment(b.updatedAt).valueOf();
      return dateB - dateA;
    });
    if (!isOnline) {
      mustSync.current = true;
    }
    queryClient.setQueryData(queryKeys.listHost, { data: zaisekiStaffListNew });

    setZaisekiStaffList(zaisekiStaffListNew);
  };

  const handleChangePage = (value: number) => {
    setRanking(value);
  };

  const handleChangeViewModal = () => {
    setViewSettingRanking(!viewSettingRanking);
  };

  return (
    <>
      <Modal
        open={showStaffModal}
        centered
        closeIcon={null}
        closable={false}
        footer={null}
        className={styles.modalStaffConfig}
        destroyOnClose
      >
        {/* <div className="overlay" onDrop={onDropTrash}></div> */}
        <div className="takuSettei staffAdminWrapper">
          <h2>
            {viewSettingRanking
              ? "スタッフ管理 > ランキング登録"
              : "スタッフ管理 > 出勤調整"}
          </h2>
          <div className="staffListWrapper">
            <div
              className="zaisekiListArea"
              onDragOver={(e) => {
                e.preventDefault(); // これがないとdropイベントが発火しない
              }}
              onDrop={onDrop1}
            >
              <h3>在籍スタッフ</h3>
              <div className="staffWrapper">
                <ul
                  className="staffList"
                  onDragOver={(e) => {
                    e.preventDefault(); // これがないとdropイベントが発火しない
                  }}
                  //onDrop={onDrop1}
                >
                  {zaisekiStaffList.map((staff, index) => {
                    return (
                      <StaffComponent
                        id={staff?.id}
                        key={staff.id}
                        onDragStart={() => {
                          dragStart1(index);
                          staffIdDrag.current = staff.id;
                        }}
                        dragEnter={() => dragEnterZaiseki(index)}
                        dragEnd={() => dragEnd(index)}
                        staffName={staff.staffName}
                        statusWorking={staff?.infoWorking?.statusWorking}
                        star={staff?.star}
                        disableShowStar={true}
                      />
                    );
                  })}
                </ul>
              </div>
            </div>
            {viewSettingRanking ? (
              <>
                <div className="rankingStaffArea">
                  <h3>売上ランキング</h3>
                  <Row
                    className={styles.rankingContainer}
                    justify="space-between"
                  >
                    {Array.from(
                      { length: defaultConfig?.data?.rankingRandom || 20 },
                      (_, index) => index + 1
                    )?.map((item: number) => (
                      <Col xs={12}>
                        <div className={styles.rankingItem} key={item}>
                          <div className={styles.label}>売上 {item}</div>
                          <div
                            className={styles.valueContainer}
                            onDragOver={(e) => {
                              e.preventDefault();
                            }}
                            onDrop={() => onDropRanking(item)}
                          >
                            <ul
                              className={classNames(
                                "staffList",
                                styles.staffListRanking
                              )}
                              onDragOver={(e) => {
                                e.preventDefault(); // これがないとdropイベントが発火しない
                              }}
                              //onDrop={onDrop1}
                            >
                              {zaisekiStaffList

                                ?.filter(
                                  (staff: any) => staff.rankingRandom === item
                                )
                                .map((staff, index) => {
                                  return (
                                    <StaffComponent
                                      id={staff.id}
                                      key={staff.id}
                                      staffName={staff.staffName}
                                      onDragStart={() => {
                                        dragInRanking.current = true;
                                        staffIdDrag.current = staff.id;
                                      }}
                                      cls="staffContainer"
                                      dragEnter={() => {
                                        setIsFromArea1(false);
                                        dragEnter(index);
                                      }}
                                      dragEnd={() => dragEnd(index)}
                                      star={staff?.star}
                                      onChangeStart={(star) =>
                                        handleChangeOrderStaff(staff.id, star)
                                      }
                                    />
                                  );
                                })}
                            </ul>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </>
            ) : (
              <>
                <div
                  className="canSelectListArea"
                  onDragOver={(e) => {
                    e.preventDefault();
                  }}
                  onDrop={onDrop2}
                >
                  <h3>当日出勤</h3>
                  <div className="staffWrapper">
                    <ul className="staffList">
                      {zaisekiStaffList
                        ?.filter(
                          (item) =>
                            item?.infoWorking?.statusWorking &&
                            [
                              StatusWorking.Working,
                              StatusWorking.WorkingLate,
                            ].includes(item?.infoWorking?.statusWorking)
                        )
                        ?.filter((item: any) => item.ranking === ranking)
                        ?.sort((a, b) => {
                          return (
                            Number(a.orderWorking) - Number(b.orderWorking)
                          );
                        })
                        .map((staff, index) => {
                          return (
                            <StaffComponent
                              id={staff.id}
                              key={staff.id}
                              staffName={staff.staffName}
                              onDragStart={() => {
                                dragStart2(index);
                                staffIdDrag.current = staff.id;
                              }}
                              cls="staffContainer"
                              dragEnter={() => dragEnter(index)}
                              dragEnd={() => dragEnd(index)}
                              star={staff?.star}
                              onChangeStart={(star) =>
                                handleChangeOrderStaff(staff.id, star)
                              }
                            />
                          );
                        })}
                    </ul>
                  </div>
                  <div className={styles.paginationContainer}>
                    <Pagination
                      defaultCurrent={1}
                      total={Number(defaultConfig?.data?.pageRanking) * 10}
                      onChange={handleChangePage}
                    />
                  </div>
                </div>
                <div
                  className="lateStaffListArea"
                  onDragOver={(e) => {
                    e.preventDefault(); // これがないとdropイベントが発火しない
                  }}
                  onDrop={onDrop3}
                >
                  <h3>遅出勤</h3>
                  <div className="staffWrapper">
                    <ul className="staffList">
                      {zaisekiStaffList
                        ?.filter(
                          (item) =>
                            item?.infoWorking?.statusWorking &&
                            [StatusWorking.WorkingLate].includes(
                              item?.infoWorking?.statusWorking
                            )
                        )
                        .map((staff, index) => {
                          return (
                            <StaffComponent
                              id={staff.id}
                              staffName={staff.staffName}
                              onDragStart={() => {
                                dragStart3(index);
                                staffIdDrag.current = staff.id;
                              }}
                              cls="staffContainer"
                              disableShowStar={true}
                              // dragEnter={() => dragEnter(index)}
                              dragEnd={() => dragEnd(index)}
                              star={staff?.star}
                            />
                          );
                        })}
                    </ul>
                  </div>
                </div>
              </>
            )}
          </div>
          <Row align="middle">
            <Col sm={8} className={styles.coldDelete}>
              <div
                className="deleteStaff"
                onDragOver={(e) => {
                  e.preventDefault(); // これがないとdropイベントが発火しない
                }}
                onDrop={onDropTrash}
              >
                <p>
                  このエリアに削除したい
                  <br />
                  在籍スタッフをドロップ
                </p>
              </div>
            </Col>
            <Col sm={8}>
              <Form onFinish={handleAddStaff} layout="horizontal" form={form}>
                <div className="staffAdd">
                  <Form.Item
                    label=""
                    name="staffName"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: "空欄にはできません。",
                      },
                    ]}
                  >
                    <input
                      type="text"
                      placeholder="追加したいホスト名を入力"
                      name="staffName"
                      onChange={handleChange}
                      value={formText}
                      maxLength={8}
                    />
                  </Form.Item>
                  <button className="staffAddBtn">追加</button>
                </div>
                <div className="staffAdminEnd">
                  <button
                    className="staffAdminEndBtn"
                    type="button"
                    onClick={handleCloseModal}
                    disabled={createHostAction?.isLoading}
                  >
                    設定を終了する
                  </button>
                </div>
              </Form>
            </Col>
            <Col className={styles.colSettingView}>
              <Row>
                <Button
                  onClick={handleChangeViewModal}
                  disabled={!viewSettingRanking}
                  className={classNames(styles.btnViewStatusWork, {
                    [styles.active]: !!viewSettingRanking,
                  })}
                >
                  {"出勤調整"}
                </Button>
                <Button
                  onClick={handleChangeViewModal}
                  disabled={viewSettingRanking}
                  className={classNames(styles.btnViewRanking, {
                    [styles.active]: !viewSettingRanking,
                  })}
                >
                  {"ランキング登録"}
                </Button>
              </Row>
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
};
